"use strict";

angular.module("licensure.services").factory("FBResponses", [
    "$http",
    "$q",
    "$rootScope",
    "$compile",
    "$timeout",
    "Documents",
    "Upload",
    "LicenseRequestApplicationTypes",
    "LicenseRequestSupplementalTrainingTrainings",
    "ServiceUserTrainings",
    "ServiceUserLongevities",
    "Logger",
    "Clinicians",
    "VoucherPay",
    "$timeout",
    function (
        $http,
        $q,
        $rootScope,
        $compile,
        $timeout,
        Documents,
        Upload,
        LicenseRequestApplicationTypes,
        LicenseRequestSupplementalTrainingTrainings,
        ServiceUserTrainings,
        ServiceUserLongevities,
        Logger,
        Clinicians,
        VoucherPay,
        $timeout
    ) {
        // --- Small helper to wait until HTML is really rendered before capturing it for PDF generation. ---
        // This guards against the "loading:finish"/"pdf:finish" global-counter race condition, where a component's
        // own async data-loading (e.g. a two-phase load like hlp-service-training-reimbursement) can still be in
        // flight even after the shared $http loading counter has momentarily hit zero.
        // This polls the live DOM until no hlp-loading indicators remain within it, or a max wait time elapses.
        /* If users experience partial captures on "Regenerate PDF", try raising PDF_MAX_WAIT_MS */
        var PDF_MAX_WAIT_MS = 8000;       // Stop waiting after this time so the user isn't stuck forever.
        var PDF_POLL_INTERVAL_MS = 180;   // How often to re-check.

        function captureWhenReady(getElementFn, done) {
            var start = performance.now();
            var pollTimer;

            function poll() {
                var elem = getElementFn();
                var domNode = elem != null && elem.length > 0 ? elem[0] : null;
                var loaderNodes = domNode != null ? domNode.querySelectorAll('.loader') : null;
                var stillLoading = loaderNodes != null && Array.prototype.some.call(loaderNodes, function (loaderNode) {
                    return !loaderNode.classList.contains('ng-hide'); // poll until loaders are hidden
                });
                var timedOut = (performance.now() - start) >= PDF_MAX_WAIT_MS;

                if (domNode == null || !stillLoading || timedOut) {
                    if (pollTimer) { $timeout.cancel(pollTimer); }

                    if (stillLoading && timedOut) {
                        Logger.logAngularApiErrors(
                            {
                                message: "PDF capture timed out while content was still loading (possible partial capture)."
                            },
                            null,
                            { url: "captureWhenReady" }
                        );
                    }
                    done(domNode != null ? domNode.innerHTML : null);
                } else {
                    pollTimer = $timeout(poll, PDF_POLL_INTERVAL_MS);
                }
            }
            pollTimer = $timeout(poll, 0); // delay first poll to allow DOM to update after initial render
        }

        var save = function (response, checklistID, saveAnswers, getLess, html, connectionId) {
            var d = $q.defer();

            var method = "POST";
            var url = apiLocation + "/api/fbresponses/";
            if (!isUndefined(response.id)) {
                method = "PUT";
                url += response.id;
            }

            if (!isUndefined(response.fbFormId)) {
                response.form_id = response.fbFormId;
            }

            $http({
                method: method,
                url: url,
                data: {
                    response: response,
                    checklistID: checklistID,
                    saveAnswers: saveAnswers,
                    getLess: getLess,
                    html: html,
                    connectionId: connectionId
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    Logger.logAngularApiErrors(response.data, response.status, response.config);
                    d.resolve(null);
                });

            return d.promise;
        };

        var saveApplicationTypeID = function (
            applicationTypeID,
            licenseRequestID
        ) {
            var d = $q.defer();

            var url =
                apiLocation + "/api/LicenseRequests/saveApplicationTypeID";
            $http({
                method: "POST",
                url: url,
                data: {
                    application_type_id: applicationTypeID,
                    license_request_id: licenseRequestID
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                    d.resolve(null);
                });

            return d.promise;
        };

        var getComponentAnswers = function (
            response,
            component,
            parentGroupID,
            parentConditionsMet,
            parentHasConditions,
            promises,
            object_id
        ) {
            var d = $q.defer();
            var root = false;
            if (promises == null) {
                promises = [];
                root = true;
            }

            if (
                component.component_type != null &&
                component.component_type.code == "form_element"
            ) {
                if (
                    component.element_code == "application_type" &&
                    component.elementAnswer != null &&
                    typeof component.elementAnswer === "object"
                ) {
                    promises.push(
                        LicenseRequestApplicationTypes.saveElement(
                            component.elementAnswer,
                            object_id
                        )
                    );
                } else if (
                    component.element_code == "supplemental_training" &&
                    response.completed_on != null &&
                    response.progress == 2
                ) {
                    //When submitting the form, log the current dates used for education verification
                    promises.push(
                        LicenseRequestSupplementalTrainingTrainings.logSupplementalDates(
                            component.response_id,
                            response.license_id,
                            response.user_id
                        )
                    );
                } else if (
                    component.element_code == "training_reimbursement" &&
                    component.elementAnswer != null &&
                    angular.isArray(component.elementAnswer)
                ) {
                    promises.push(
                        ServiceUserTrainings.saveElement(
                            component.elementAnswer,
                            object_id
                        )
                    );
                } else if (
                    component.element_code == "longevity_credits_approval" &&
                    component.elementAnswer != null &&
                    angular.isArray(component.elementAnswer)
                ) {
                    promises.push(
                        ServiceUserLongevities.saveElement(
                            component.elementAnswer,
                            object_id
                        )
                    );
                } else if (
                    component.element_code == "clinicians_import" &&
                    component.elementAnswer != null &&
                    angular.isArray(component.elementAnswer)
                ) {
                    promises.push(
                        Clinicians.saveElement(
                            component.elementAnswer,
                            object_id,
                            response.id,
                            response.completed_on != null ? true : false
                        )
                    );
                    component.elementAnswer[0].saved = true;
                } else if (
                    component.element_code == "voucher_pay" &&
                    component.elementAnswer != null &&
                    angular.isArray(component.elementAnswer)
                ) {
                    promises.push(
                        VoucherPay.saveElement(
                            component.elementAnswer,
                            response.license_request_id,
                            response.completed_on != null ? true : false
                        )
                    );
                }
            } else {
                var sort_order = 1;
                component.groups.forEach(function (group, gIndex) {
                    group.sort_order = sort_order++;
                    group.parent_group_id = parentGroupID;

                    var saveGroup = angular.copy(group);
                    saveGroup.questions = null;
                    saveGroup.answers = [];
                    group.questions.forEach(function (question) {
                        if (
                            question.data_point_code ==
                            "certification_application_type" &&
                            question.answer != null &&
                            question.answer.value != null
                        ) {
                            promises.push(
                                saveApplicationTypeID(
                                    question.answer.value,
                                    object_id
                                )
                            );
                        }

                        // Check for required signature on forms before save
                        if (question.signature !== undefined) {
                            question.answer.signature_photo_source = question.signature.toDataURL();
                            if (question.data_point_id === null && question.signature && question.signature._isEmpty && question.required) {
                                response.signatureError = (question.required_message) ? question.required_message : "Required information is missing. Please sign the signature box.";
                                question.answer.signature_photo_source = null;
                                d.resolve(response);
                                return d.promise;
                            }
                        }

                        var answer = angular.copy(question.answer);

                        // if question is of type date, we want to applyTimeZone so that when we save FB_Answer and convert from a JSON Date to a C# String, we cancel out the
                        // offset
                        if (question.question_type.code == "date") {
                            if (answer.value) {
                                // Ensure we have a date object. Portal Inspections stringify the data for cache and here we convert it back.
                                if (typeof answer.value === 'string' || typeof answer.value === 'number') { answer.value = new Date(answer.value); }
                                if (answer.value instanceof Date && !isNaN(answer.value)) {
                                    answer.value = new Date(answer.value.applyTimeZone());
                                }
                            }
                        }

                        if (angular.isArray(answer.value)) {
                            var value = null;

                            answer.value.forEach(function (val) {
                                var v = "";
                                if (angular.isObject(val)) {
                                    v = val.id;
                                } else {
                                    v = val;
                                }

                                if (value == null) {
                                    value = v;
                                } else {
                                    value += "," + v;
                                }
                            });

                            answer.value = value;
                        }

                        // Document Save
                        if (
                            answer.file_updated &&
                            answer.file_content !== null &&
                            answer.file_name !== null &&
                            answer.document_id === null &&
                            answer.document_saved === undefined &&
                            component.conditions_met === true
                        ) {
                            promises.push(
                                Documents.upload(
                                    {
                                        file: Upload.dataUrltoBlob(
                                            answer.file_content,
                                            answer.file_name
                                        ),
                                        name: answer.document_name,
                                        description: answer.document_description,
                                        document_type_id: answer.document_type
                                    },
                                    object_id
                                ).then(function (document) {
                                    if (document == null) {
                                        //Something errored in the backend
                                        return { error: true, document_name: answer.document_name || answer.file_name };
                                    }
                                    else {
                                        if (answer.document_id) {
                                            // delete the old document
                                            promises.push(
                                                Documents.delete(
                                                    angular.copy(answer.document_id)
                                                ).then(function (result) {
                                                    console.log(result);
                                                })
                                            );
                                        }
                                        answer.document_id = document.id;
                                        question.answer.document_id = document.id;
                                        answer.document_code = document.code;
                                        question.answer.document_saved = true;
                                    }
                                })
                            );
                        } else if (answer.document_id !== null && answer.document_saved !== true && component.conditions_met === true) {
                            promises.push(
                                Documents.save(
                                    {
                                        id: answer.document_id,
                                        name: answer.document_name,
                                        description:
                                            answer.document_description,
                                        document_type_id: answer.document_type,
                                        locked: answer.document_locked != null ? answer.document_locked : false
                                    },
                                    false
                                )
                            );
                            question.answer.document_saved = true;
                        }

                        answer.file_content = null;

                        saveGroup.answers.push(answer);

                        question.sub_components.forEach(function (subComponent) {
                            getComponentAnswers(
                                response,
                                subComponent,
                                group.id,
                                component.conditions_met,
                                component.component_conditions.length > 0,
                                promises,
                                object_id
                            );
                        });
                    });
                    // clear out values of components that didn't meet conditions
                    if (
                        !(
                            (component.component_conditions.length > 0 &&
                                component.conditions_met == false) ||
                            (parentHasConditions &&
                                parentConditionsMet == false)
                        )
                    ) {
                        response.groups.push(saveGroup);
                    }
                });
            }

            if (root) {
                $q.all(promises).then(function (results) {
                    d.resolve(results);
                }).catch(function (response) {
                    // handle error
                });
            } else {
                d.resolve();
            }

            return d.promise;
        };

        var generatePDFHTML = function (form, parameters) {
            var d = $q.defer();
            var pdfScope = $rootScope.$new(true);
            pdfScope.form = form;
            pdfScope.form.portalURL = $rootScope.portalURL;
            pdfScope.parameters = parameters;
            parameters.display_changed_answers = form.display_changed_answers;

            var element = $compile(
                '<hlp-form-builder-form-pdf form="form" parameters="parameters"></hlp-form-builder-form-pdf>'
            )(pdfScope);

            function cleanup() {
                if (element) {
                    element.off();
                    element.remove();
                    element = null;
                }
                if (pdfScope) {
                    pdfScope.$destroy();
                    pdfScope = null;
                }
            }

            var pdfListener = $rootScope.$on("pdf:finish", function () {
                pdfListener();

                captureWhenReady(function () {
                    return element;
                }, function (html) {
                    d.resolve(html);
                    cleanup();
                });
            });

            pdfScope.$on("$destroy", function () {
                pdfListener();
                cleanup();
            });

            return d.promise;
        };

        var getByID = function (id, previewFormID, preview) {
            var d = $q.defer();

            $http
                .get(apiLocation + "/api/fbresponses/" + id, {
                    params: {
                        previewFormID: previewFormID,
                        preview: preview
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        };

        var getCertificationDataSetQuery = function (userId, serviceId, vehicleId, licenseCategoryId, licenseRequestId) {
            var d = $q.defer();

            $http
                .get(apiLocation + "/api/fbresponses/CertificationDataSetData", {
                    params: {
                        userId: userId,
                        serviceId: serviceId,
                        vehicleId: vehicleId,
                        licenseCategoryId: licenseCategoryId,
                        licenseRequestId: licenseRequestId
                    }
                })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        };

        return {
            getByID: getByID,

            save: save,

            generatePDFHTML: generatePDFHTML,

            getCertificationDataSetQuery: getCertificationDataSetQuery,

            saveByForm: function (
                response,
                object_id,
                page_count,
                getLess,
                skipLogging,
                dont_save,
                saveAnswers,
                html,
                connectionId
            ) {
                var d = $q.defer();
                var promises = [];

                var tempResponse = Object.assign({}, response); // Soft copy
                delete tempResponse.form.the_form; // This object has scope vars & cannot be copied, delete that object to be copied
                var saveResponse = angular.copy(tempResponse);

                saveResponse.form = null;
                saveResponse.groups = [];
                saveResponse.pages = [];
                response.form.pages.forEach(function (page, index) {
                    if (page_count == null || index <= page_count) {
                        saveResponse.pages.push({ id: page.id, active: page.tab_active });
                        page.sections.forEach(function (section) {
                            section.components.forEach(function (component) {
                                promises.push(
                                    getComponentAnswers(
                                        saveResponse,
                                        component,
                                        null,
                                        true,
                                        false,
                                        null,
                                        object_id
                                    )
                                );
                            });
                        });
                    }
                });

                $q.all(promises).then(function (results) {
                    if (dont_save || saveResponse.signatureError) {
                        d.resolve(saveResponse);
                    } else {
                        save(saveResponse, null, saveAnswers, getLess, html, connectionId).then(function (
                            data
                        ) {
                            saveResponse = null;
                            var parsedResults = results != null ? results.filter(function (result) { return (result != null); }).flat() : null;
                            if (parsedResults != null && parsedResults.length > 0 && data != null && data != false) {
                                data.documentErrors = parsedResults.filter(function (result) { return (result != null && result.error == true) });
                            }

                            d.resolve(data);
                        });
                    }
                }).catch(function (response) {
                    // handle error
                });

                return d.promise;
            },

            generatePDF: function (
                response_obj,
                object_id,
                parameters,
                skipLogging
            ) {
                var d = $q.defer();

                generatePDFHTML(response_obj.form, parameters).then(function (html) {
                    $http
                        .post(apiLocation + "/api/FBResponses/generatepdf", {
                            html: html,
                            objectID: object_id,
                            responseID: response_obj.id,
                            licenseRequestID: response_obj.license_request_id,
                            formID: response_obj.form_id
                        })
                        .then(function (response) {
                            if (skipLogging) {
                                d.resolve(response.data);
                            } else {
                                Logger.logFormProgress(
                                    "Generated PDF",
                                    response_obj.id
                                );
                                d.resolve(response.data);
                            }
                        })
                        .catch(function (response) {
                            if (skipLogging) {
                                console.log(response.data);
                                d.resolve(null);
                            } else {
                                Logger.logFormProgress(
                                    "Error Generating PDF" + response.data,
                                    response_obj.id
                                );
                                console.log(response.data);
                                d.resolve(null);
                            }
                        });
                });

                return d.promise;
            },

            getPDFFileContent: function (form, parameters, builder) {
                var d = $q.defer();

                if (builder === true) {
                    //If we're in the formbuilder, need to get the full form from the backend
                    getByID(guid(), form.id).then(function (response) {
                        if (response) {
                            generatePDFHTML(response.form, parameters).then(function (html) {
                                $http
                                    .post(
                                        apiLocation + "/api/FBResponses/getPDFFileContent",
                                        {
                                            html: html,
                                            name: response.form.name ? response.form.name : "application",
                                            formID: form.id
                                        }
                                    )
                                    .then(function (response) {
                                        d.resolve(response.data);
                                    })
                                    .catch(function (response) {
                                        d.resolve(null);
                                    });
                            });
                        }
                    });
                }
                else {
                    generatePDFHTML(form, parameters).then(function (html) {
                        $http
                            .post(
                                apiLocation + "/api/FBResponses/getPDFFileContent",
                                {
                                    html: html,
                                    responseID: parameters.response_id,
                                    licenseRequestID: parameters.license_request_id,
                                    name: parameters.document_name,
                                    formID: form.id
                                }
                            )
                            .then(function (response) {
                                d.resolve(response.data);
                            })
                            .catch(function (response) {
                                console.log(response.data);
                                // handle error
                            });
                    });
                }

                return d.promise;
            },

            populateGroup: function (dataSetCode, coreID, serviceID, single) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/FBResponses/populateGroup", {
                        params: {
                            data_set_code: dataSetCode,
                            core_id: coreID,
                            service_id: serviceID,
                            single_group: single
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            clearSignatures: function (id) {
                var d = $q.defer();

                var data = {
                    responseID: id
                };

                $http({
                    method: "POST",
                    url: apiLocation + "/api/fbresponses/clearsignatures",
                    data: data
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            reopen: function (id, licenseRequestID, skipLogging) {
                var d = $q.defer();

                var data = {
                    responseID: id,
                    licenseRequestID: licenseRequestID
                };

                $http({
                    method: "POST",
                    url: apiLocation + "/api/fbresponses/reopen",
                    data: data
                })
                    .then(function (response) {
                        if (skipLogging) {
                            d.resolve(response.data);
                        } else {
                            Logger.logFormProgress("Reopened form", id);
                            d.resolve(response.data);
                        }
                    })
                    .catch(function (response) {
                        if (skipLogging) {
                            d.resolve(null);
                        } else {
                            Logger.logFormProgress(
                                "Error Reopening form: " + response.data,
                                id
                            );
                            d.resolve(null);
                        }
                    });

                return d.promise;
            },

            delete: function (id, skipLogging) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/fbresponses/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        if (skipLogging) {
                            d.resolve(response.data);
                        } else {
                            Logger.logFormProgress("Deleted", id);
                            d.resolve(response.data);
                        }
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },

            getServiceApplicationVehicles: function (licenseRequestIDs) {
                var d = $q.defer();

                $http.post(apiLocation + "/api/fbresponses/GetServiceApplicationVehicles", {
                    licenseRequestIDs: licenseRequestIDs
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },
        };
    }
]);